import { defineQueries } from "@rocicorp/zero";
import { crewQueries } from "./crew.queries";
import { fileClassificationQueries } from "./file-classification.queries";
import { organizationQueries } from "./organization.queries";
import { planQueries } from "./plan.queries";
import { projectQueries } from "./project.queries";
import { ticketAssignmentQueries } from "./ticket-assignment.queries";
import { userAssignmentQueries } from "./user-assignment.queries";
import { vehicleAssignmentQueries } from "./vehicle-assignment.queries";
import { videoQueries } from "./video.queries";

export const queries = defineQueries({
	crews: crewQueries,
	fileClassifications: fileClassificationQueries,
	projects: projectQueries,
	ticketAssignments: ticketAssignmentQueries,
	userAssignments: userAssignmentQueries,
	plans: planQueries,
	organizations: organizationQueries,
	vehicleAssignments: vehicleAssignmentQueries,
	videos: videoQueries,
});
